import script from "./AuthHeroPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthHeroPanel.vue?vue&type=script&setup=true&lang=js"

import "./AuthHeroPanel.vue?vue&type=style&index=0&id=61c36499&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61c36499"]])

export default __exports__